export default function formatEvaluationFormValues(form, formValues, language) {
	const formattedValues = { ...formValues };

	Object.entries(formValues).forEach(([key, value]) => {
		// type dropdown
		if (typeof value === 'object' && value !== null) {
			formattedValues[key] = value.value;
		}
		// type multi
		if (Array.isArray(value)) {
			const selectedOptions = value.map((selectedOption) => selectedOption.value);
			form.sections.forEach((section) => {
				section.fields.forEach((formField) => {
					if (formField.id === key) {
						delete formattedValues[key];
						formField.options.forEach((option, index) => {
							formattedValues[`${key}_${index}`] = selectedOptions.includes(`${key}_${index}`) ? '1' : '0';
						});
					}
				});
			});
		}
	});

	return { ...formattedValues, language };
}
